import React from 'react';
import { FormattedMessage } from 'react-intl';
import NegativeToast from '@/components/toasts/NegativeToast';

const UsergroupRemoveErrorToast = ({ group, user }) => (
  <NegativeToast className="aridhia-usergroup-remove-error-toast" icon="times circle">
    <FormattedMessage id="usergroup.user.removal.error" values={{ userName: user.name, groupName: group.name }} />
  </NegativeToast>
);

export default UsergroupRemoveErrorToast;
